import IntegrationsTable from '@/components/IntegrationsTable.tsx';
import { useDynamicPageSettingsContext } from './DynamicPageSettingsContext';
import { DynamicPageSettingsModalTabWrapper } from './DynamicPageSettingsModalTabWrapper';

export const Integrations = () => {
  const { dynamicPageId } = useDynamicPageSettingsContext();

  return (
    <DynamicPageSettingsModalTabWrapper
      edit={false}
      onDiscard={function (): void {
        throw new Error('Function not implemented.');
      }}
      onSave={function (): void {
        throw new Error('Function not implemented.');
      }}
    >
      <div className="col-span-2">
        <IntegrationsTable dynamicPageId={dynamicPageId} />
      </div>
    </DynamicPageSettingsModalTabWrapper>
  );
};
